import { action, observable } from 'mobx';

export class PointTranslationRotationVM {
  @observable shouldDisplayOnMap = false;
  @observable props;
  constructor(props: any) {
    this.props = props;
  }

  @action.bound onChangeHandler() {
    this.props.setFormError('');
  }
}
